import CloseIcon from 'components/ReusableComponents/CloseIcon'
import MoreIcon from 'components/ReusableComponents/Icons/More'
import { getChatRouteFromMessagingType } from 'features/Messaging/messaging-helpers'
import useClickOut from 'hooks/useClickOut'
import useMessageFollowUp from 'hooks/useMessageFollowUp'
import { useRef, useState } from 'react'
import { Link } from 'react-router-dom'

import styles from './FollowUpButtons.module.scss'

const FollowUpButton = ({ link, guestName, onDeleteClick, hotelDisplayId, note }) => (
  <div className={styles.button}>
    <Link to={link}>{guestName}</Link>
    <button className={styles.closeButton} onClick={() => onDeleteClick()}>
      <CloseIcon />
    </button>
    <div className={styles.tooltip}>
      <div>Hotel: #{hotelDisplayId}</div>
      {note && <div>Notes: {note}</div>}
    </div>
  </div>
)

const FollowUpButtons = () => {
  const { followUps, deleteFollowUp } = useMessageFollowUp()

  const [showingMoreButtons, setShowingMoreButtons] = useState(false)

  const followUpsArr = Object.values(followUps)

  const moreButtonRef = useRef()

  useClickOut(moreButtonRef, () => {
    if (showingMoreButtons) {
      setShowingMoreButtons(false)
    }
  })

  if (followUpsArr.length > 0) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.cardHolder}>
          {followUpsArr
            .slice()
            .reverse()
            .slice(0, 4)
            .map(f => (
              <FollowUpButton
                key={f.chatId}
                link={`/s/${f.hotelId}${getChatRouteFromMessagingType(f.messagingType)}/${
                  f.chatId
                }`}
                guestName={f.guestName}
                onDeleteClick={() => deleteFollowUp(f.chatId)}
                note={f.note}
                hotelDisplayId={f.hotelDisplayId}
              />
            ))}
        </div>

        {followUpsArr.length > 4 && (
          <>
            <button
              className={styles.moreButton}
              onClick={() => setShowingMoreButtons(true)}
              ref={moreButtonRef}
            >
              <MoreIcon className={styles.moreIcon} />
              {showingMoreButtons && (
                <div className={styles.moreButtonsHolder}>
                  {followUpsArr
                    .slice()
                    .reverse()
                    .slice(4, followUpsArr.length)
                    .map(f => (
                      <FollowUpButton
                        key={f.chatId}
                        link={`/s/${f.hotelId}${getChatRouteFromMessagingType(
                          f.messagingType
                        )}/${f.chatId}`}
                        guestName={f.guestName}
                        onDeleteClick={() => deleteFollowUp(f.chatId)}
                      />
                    ))}
                </div>
              )}
            </button>
          </>
        )}
      </div>
    )
  } else {
    return null
  }
}

export default FollowUpButtons
